export default __webpack_public_path__ + "static/buildabase-4a4c8ff749e87d9be8e1c6fdb5396523.svg";